import camelCase from "lodash/camelCase"

import { AuthData } from "@/api/resources/auth/types"
import { transformKeys } from "@/api/utils"
import { BROWSER_STORAGE_KEYS, PLATFORM } from "@/lib/constants"

export const redirectToLogin = () => {
  const url = new URL("/rotary/signin", import.meta.env.VITE_SSO_URL)

  url.searchParams.append("platform", PLATFORM)
  url.searchParams.append("redirect-url", window.location.href)
  // console.log("Redirecting to login:", url.toString())
  window.location.href = url.toString()
}

export const redirectToLogout = () => {
  // posthog.reset()

  const url = new URL(`${import.meta.env.VITE_SSO_URL}/rotary/logout`)

  url.searchParams.append("platform", PLATFORM)
  url.searchParams.append("redirect-url", `${window.location.origin}/`)

  window.location.href = url.toString()
}

export function getAuthInfo() {
  const authInfo = localStorage.getItem(BROWSER_STORAGE_KEYS.auth)

  if (authInfo !== null) {
    const newAuthInfoObj: AuthData = transformKeys(
      JSON.parse(authInfo),
      camelCase,
    )
    return newAuthInfoObj
  }

  return authInfo
}

export function saveAuthInfo(authInfo: AuthData) {
  const auth = BROWSER_STORAGE_KEYS.auth

  const oldAuthToken = getAuthInfo()?.accessToken
  const newAuthToken = authInfo.accessToken
  localStorage.setItem(
    auth,
    JSON.stringify({
      ...authInfo,
      expiresAt:
        oldAuthToken !== newAuthToken
          ? new Date().toISOString()
          : authInfo.expiresAt,
    }),
  )
}

export function removeAuthInfo() {
  localStorage.removeItem(BROWSER_STORAGE_KEYS.auth)
}
